import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

type NotFoundProps = {
  previousPath?: string;
  dataName?: string;
};

const NotFound: React.FC<NotFoundProps> = ({ dataName, previousPath }) => {
  const navigate = useNavigate();
  const displayName = dataName
    ? `${dataName.charAt(0).toUpperCase()}${dataName.slice(1)}`
    : 'Page';

  const handleGoBack = () => {
    if (previousPath) {
      navigate(previousPath);
      return;
    }
    navigate('/');
  };

  return (
    <div
      className="flex flex-col items-center justify-center min-h-[60vh] w-full px-4 py-16 font-raleway bg-[#FFFFFF]"
      role="alert"
      aria-live="polite"
    >
      <div className="flex flex-col items-center text-center max-w-md w-full border border-[#E9E9E9] rounded-xl bg-white p-8 md:p-10 shadow-sm">
        <p className="text-[72px] md:text-[80px] font-bold text-primaryDark-0/20 leading-none mb-3 select-none">
          404
        </p>
        <h1 className="text-[20px] md:text-[24px] font-semibold text-black mb-2">
          {displayName} Not Found
        </h1>
        <p className="text-[14px] font-open-sans text-[#8A8A8A] mb-8 leading-relaxed">
          {dataName
            ? `The ${dataName} you're looking for doesn't exist or may have been removed.`
            : "The page you're looking for doesn't exist or may have been removed."}
        </p>
        <button
          type="button"
          onClick={handleGoBack}
          className="inline-flex items-center justify-center gap-1 bg-primaryDark-0 hover:bg-primaryDark-300 text-white font-raleway font-bold text-[14px] rounded-md border-0 py-3 px-6 transition-colors cursor-pointer"
        >
          <ArrowBackIosIcon sx={{ fontSize: 14 }} />
          Go Back Home
        </button>
      </div>
    </div>
  );
};

export default NotFound;
